import React, { Component } from 'react';
import LinkRow from '../components/linkRow';
import { chunkArray } from '../_utils/arrayUtils';
import { localLinks } from '../data/links';

class LocalLinks extends Component {
    render() {
        const chunkedLinks = chunkArray(localLinks, 3);

        const rows = chunkedLinks.map((chunk, i) => (
            <LinkRow key={i} links={chunk} />
        ));

        return (
            <div className="links">
                <h5>Local Links</h5>
                {rows}
            </div>
        );
    }
}

export default LocalLinks;


// WEBPACK FOOTER //
// ./src/components/localLinks.jsx